<template>
  <div>
    <OnboardingIndex
      :title="title"
      :submitButtonText="submitButtonText"
      :url_forgot_password="url_forgot_password"
      :verification_running="verification_running"
      @custom-submit="login_function"
    >
      <template v-slot:form-content>
        <!-- Email Field -->
        <div class="mb-2">
          <label for="email" class="text-xxs">Email</label>
          <input
            type="email"
            class="form-control form-control-lg text-xxs bg-light border-0 py-3"
            v-model="username"
            id="email"
            placeholder="Enter your email address"
            required
          />
        </div>

        <!-- Password Field -->
        <div class="mb-2 position-relative">
          <label for="password" class="text-xxs">Password</label>
          <input
            :type="show_password ? 'text' : 'password'"
            class="form-control form-control-lg text-xxs bg-light border-0 py-3 pe-5"
            v-model="password"
            id="password"
            placeholder="Enter your password"
            required
          />
          <i 
            :class="show_password ? 'bi bi-eye' : 'bi bi-eye-slash'"
            class="position-absolute end-0 top-50 translate-middle-y-eye me-3 text-secondary cursor-pointer z-2"
            @click="toggle_password_visibility"
          ></i>
        </div>

        <!-- Login-specific elements -->
        <div class="d-flex justify-content-between align-items-center mt-4 mb-4">
          <div class="form-check mb-0">
            <input class="form-check-input" type="checkbox" id="show-password" />
            <label class="form-check-label" for="show-password"> Remember me </label>
          </div>
          <p class="mb-0">
            <a :href="url_forgot_password" class="text-decoration-none text-primary fw-bold">
              Forgot password?
            </a>
          </p>
        </div>
      </template>

      <!-- Sign-up link -->
      <template v-slot:signup-content>
        <p v-if="show_enquiry_link" class="mt-3 mb-0">
          Got a question?
          <router-link 
            :to="{ path: '/prospective_applicant' }"
            class="text-primary text-decoration-none fw-bold"
          >
            Enquire Here
          </router-link>
        </p>
      </template>
      
    </OnboardingIndex>
  </div>
</template>